// extracted by mini-css-extract-plugin
export var container = "CreatureCheatMatrix-module--container--6effe";
export var labelCell = "CreatureCheatMatrix-module--labelCell--7ddd9";
export var legend = "CreatureCheatMatrix-module--legend--a8bb6";
export var legendContainer = "CreatureCheatMatrix-module--legendContainer--b1146";
export var row = "CreatureCheatMatrix-module--row--00e89";
export var valueCell = "CreatureCheatMatrix-module--valueCell--5cddb";